import React, { useEffect, useMemo } from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import ParkkiTheme from "themes/ParkkiTheme";
import NonMovingCarsActioner from "services/nonMovingCars/actioner";

import TimeInput from "components/TimeInput";
import Section from "components/Section";

import Filters from "components/Filters";
import NonMovingCarsTable from "scenes/NonMovingCars/components/nonMovingCarsTable";

const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: ${ParkkiTheme.colors.lightGrey};
  flex-direction: column;
`;

const FiltersContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
`;

const FilterContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  max-width: 250px;
`;

const TimeInputContainer = styled.div`
  display: flex;
  flex: 1;
`;

const StyledLabel = styled.label`
  font-size: 20px;
  padding-left: 5px;
`;

const TotalContainer = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 12px;
`;

function NonMovingCarsLayout({
  currentFilters,
  currentFloor,
  globalFilters,
  nonMovingCars,
  retrieveNonMovingCars,
  setFilter,
  setHoverIndex,
  setOrders,
  setSelectedIndex,
}) {
  const intl = useIntl();

  useEffect(() => {
    retrieveNonMovingCars();
  }, [
    currentFloor,
    currentFilters?.duration,
    currentFilters?.areaType,
    retrieveNonMovingCars,
  ]);

  const formattedFilters = useMemo(() => {
    return globalFilters.map((filter) => ({
      ...filter,
      selected: currentFilters?.areaType?.indexOf(filter.value) >= 0,
    }));
  }, [currentFilters, globalFilters]);

  function handleUpdateDuration(value) {
    setFilter("duration", value);
  }

  function handleUpdateAreaType(value) {
    setFilter("areaType", value);
  }

  function handleSetOrders(values) {
    setOrders(values);
    return retrieveNonMovingCars();
  }

  return (
    <Container>
      <FiltersContainer>
        <TimeInputContainer>
          <TimeInput
            label={intl.messages["components.timeSlider.floatingLabel"]}
            duration={currentFilters?.duration}
            onSubmit={handleUpdateDuration}
          />
        </TimeInputContainer>

        <FilterContainer>
          <Filters
            filters={formattedFilters}
            setFilters={handleUpdateAreaType}
          />
        </FilterContainer>
      </FiltersContainer>
      <div>
        <Section
          title={intl.messages["nonMovingCarsScene.title"]}
          subtitle={
            <TotalContainer>
              <StyledLabel>
                {(nonMovingCars?.items && nonMovingCars?.length) || 0}
              </StyledLabel>
            </TotalContainer>
          }
        >
          <NonMovingCarsTable
            nonMovingCars={nonMovingCars}
            onRowHover={setHoverIndex}
            setOrders={handleSetOrders}
            onRowSelection={setSelectedIndex}
          />
        </Section>
      </div>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  currentFloor: state.Map?.config?.currentFloor,
  currentFilters: state.NonMovingCars.filters,
  globalFilters: state.GlobalFilters.filters,
  nonMovingCars: state.NonMovingCars.list,
});

const mapDispatchToProps = (dispatch) => ({
  retrieveNonMovingCars: () =>
    dispatch(NonMovingCarsActioner.retrieveList("radius")),
  setFilter: (key, value) =>
    dispatch(NonMovingCarsActioner.setFilter(key, value)),
  setHoverIndex: (index) =>
    dispatch(NonMovingCarsActioner.setHoverIndex(index)),
  setOrders: (orders) => dispatch(NonMovingCarsActioner.setOrders(orders)),
  setSelectedIndex: (index) =>
    dispatch(NonMovingCarsActioner.setSelectedIndex(index)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonMovingCarsLayout);
